/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Resourcespermissionsdescription2Inputs */

const en_settings_resourcespermissionsdescription2 = /** @type {(inputs: Settings_Resourcespermissionsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See a table breakdown of roles and permissions`)
};

/**
* | output |
* | --- |
* | "See a table breakdown of roles and permissions" |
*
* @param {Settings_Resourcespermissionsdescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_resourcespermissionsdescription2 = /** @type {((inputs?: Settings_Resourcespermissionsdescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Resourcespermissionsdescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_resourcespermissionsdescription2(inputs)
});
export { settings_resourcespermissionsdescription2 as "settings_resourcesPermissionsDescription" }